import StyledErrorMessage from './StyledErrorMessage'

export default StyledErrorMessage
